// @ts-ignore
import * as ReactGA from 'react-ga';
// @ts-ignore
import * as TagManager from 'react-gtm-module'
import Config from "../Config/Config";

const tagManagerVurtusalPage = {
    gtmId: Config.isProd()? Config.googleTagManagerId() :  "GTM-5V97G84",
    dataLayerName: 'virtualPageView'
};
ReactGA.initialize(Config.isProd()? 'UA-102042910-1' :  'UA-102042910-4');
TagManager.initialize(tagManagerVurtusalPage);

export default class GoogleAnalyticsService {
    public static triggerEvent(category: string, action: string, label?: string) {
            ReactGA.event({category, action, label});
    }

    public static virtualPageView = (pathName : string) => {
        ReactGA.pageview(pathName);
    };
}


// WEBPACK FOOTER //
// ./src/services/Analytics/GoogleAnalyticsService.ts